import { Controller } from "@hotwired/stimulus"

/**
 * 在庫情報確認画面用のStimulusコントローラー
 */
export default class extends Controller {
  /**
   * チェックボックス変更時にフォームを送信（セッション更新のみ）
   */
  submitForSessionUpdate() {
    const form = document.getElementById("stock-confirmation-form")
    if (!form) {
      return
    }

    form.requestSubmit()
  }
}
